import React, { useState } from 'react';

const ContactForm = ({ submitBtnClass }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        website: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('http://localhost:3031/api/v1/form', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            const result = await response.json();
            if (response.ok) {
                alert('Form submitted successfully');
                setFormData({ name: '', email: '', phone: '', website: '', message: '' });
            } else {
                alert(`Failed to submit: ${result.message}`);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('Something went wrong. Try again.');
        }
    };

    return (
        <form id="contact-form" onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-md-6 mb-30">
                    <input className="from-control" type="text" name="name" placeholder="Name" required value={formData.name} onChange={handleChange} />
                </div>

                <div className="col-md-6 mb-30">
                    <input className="from-control" type="text" name="email" placeholder="E-Mail" required value={formData.email} onChange={handleChange} />
                </div>

                <div className="col-md-6 mb-30">
                    <input className="from-control" type="text" name="phone" placeholder="Phone Number" required value={formData.phone} onChange={handleChange} />
                </div>

                <div className="col-md-6 mb-30">
                    <input className="from-control" type="text" name="website" placeholder="Your Website" required value={formData.website} onChange={handleChange} />
                </div>

                <div className="col-12 mb-30">
                    <textarea className="from-control" name="message" placeholder="Your message Here" required value={formData.message} onChange={handleChange}></textarea>
                </div>
            </div>
            <div className="btn-part">
                <button className={submitBtnClass ? submitBtnClass : 'readon learn-more submit'} type="submit">Submit Now</button>
            </div>
        </form>
    );
};

export default ContactForm;